module.exports = __webpack_public_path__ + "static/media/1_12.499964e2.jpg";